import React from 'react';

export type Props = {shopName: string; shopUrl: string};

export const HomepageAlert = ({shopName, shopUrl}: Props) => {
  function openAlert(name: string, url: string) {
    alert(`hello, welcome to ${name} (${url})`);
  }

  return (
    <>
      <button
        className="button button--primary button--full"
        onClick={() => openAlert(shopName, shopUrl)}
      >
        Where am I?
      </button>
    </>
  );
};
